// action - state management
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dialogOpen: false,
  dialogContent: 'Are you sure you want to do that?',
  dialogButtons: ['Cancel', 'OK'],
  dialogTitle: 'Confirm',
  dialogFunction: () => {},
  dialogResult: false
};

// ===========================|| DIALOG REDUCER ||=========================== //

const dialog = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    setDialogOpen(state, action) {
      state.dialogOpen = action.payload.dialogOpen;
      state.dialogContent = action.payload.dialogContent;
      state.dialogButtons = action.payload.dialogButtons;
      state.dialogTitle = action.payload.dialogTitle;
      state.dialogFunction = action.payload.dialogFunction;
    },
    setDialogResult(state, action) {
      state.dialogResult = action.payload;
      state.dialogOpen = false;
    }
  }
});

export default dialog.reducer;

export const { setDialogOpen, setDialogResult } = dialog.actions;
